import { createForm } from "../../../Common/EditProfile/formContext";

export type RegistrationEducationFormType = {
  school: string;
  yearsOfPractice?: number;
};

export const { useFormContext, FormProvider } = createForm<RegistrationEducationFormType>();
